import React from 'react';

/**
 * Simple error boundary for wrapping individual components/routes.
 * Reports errors to Sentry when available (loaded lazily via window.Sentry).
 */
class SimpleErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Component crashed:', error, errorInfo);

    if (window.Sentry) {
      window.Sentry.captureException(error, {
        extra: { componentStack: errorInfo?.componentStack }
      });
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: '1rem',
          backgroundColor: '#fee',
          border: '1px solid #faa',
          borderRadius: '4px',
          textAlign: 'center'
        }}>
          <p style={{ margin: 0 }}>出现了问题，请刷新页面重试</p>
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: '0.5rem',
              padding: '0.5rem 1rem',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            刷新页面
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default SimpleErrorBoundary;
